<template>
  <Wrap class="sm">
    <FormFloat :title="$t('title')" @submit="sendEmail">
      <transition name="slide-down">
        <Notice v-if="message" :class="message.theme">
          {{ message.text }}
        </Notice>
      </transition>
      <template v-if="!hasSent">
        <Field
          autocomplete="email"
          :label="$t('email')"
          required
          type="email"
          :value.sync="email" />
        <NoticeRecaptcha />
        <Btn :isLoading="isLoading" type="submit">
          {{ $t('reset') }}
        </Btn>
      </template>
    </FormFloat>
  </Wrap>
</template>

<script>
import FormFloat from 'views/components/FormFloat'
import Message from 'views/mixins/Message'
import Meta from 'views/mixins/Meta'
import Recaptcha from 'views/mixins/Recaptcha'
import { actions } from 'views/utils'

export default {
  mixins: [
    Message,
    Meta(),
    Recaptcha,
  ],
  components: { FormFloat },
  data() {
    return {
      email: '',
      isLoading: false,
      hasSent: false,
    }
  },
  methods: {
    async sendEmail() {
      this.success(this.$t('sending'))

      try {
        this.isLoading = true
        await this.PATCH_AUTHMANAGEMENT(await this.injectRecaptcha({
          id: null,
          email: this.email,
          resetToken: true,
        }, 'resetPassword'))
        this.hasSent = true
        this.success(this.$t('success'))
      } catch (error) {
        this.danger(error.message || this.$t('alreadySent'))
      } finally {
        this.isLoading = false
      }
    },
    ...actions('PATCH_AUTHMANAGEMENT'),
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "meta": {
      "title": "Password Reset",
      "description": "Forgot your password? You can reset it here."
    },
    "title": "Password reset",
    "email": "Email",
    "reset": "Reset password",
    "sending": "Sending password reset email...",
    "success": "Perfect! Please check your email inbox for instructions!",
    "alreadySent": "We have already sent a password reset email"
  }
}
</i18n>
